export const SHOW_WARN_POPUP = 'SHOW_WARN_POPUP';
export const HIDE_WARN_POPUP = 'HIDE_WARN_POPUP';
export const SET_WARN_POPUP_TEXT = 'SET_WARN_POPUP_TEXT';
export const SET_WARN_POPUP_USERID = 'SET_WARN_POPUP_USERID';
